import DeleteIcon from '@mui/icons-material/DeleteOutlined';

import { TEXT_COLOR, TEXT_SIZE } from '@components/Text';
import { DeleteActionButton } from '../../shared/tabStyles';

export const POPULATION_OPTIONS = [
  { label: 'Children', value: 'CHILDREN' },
  { label: 'Adults', value: 'ADULTS' },
];

export const TYPE_OPTIONS = [
  { label: 'Basic', value: 'topicBasic' },
  { label: 'Advanced', value: 'topicAdvanced' },
  { label: 'Medium', value: 'topicMedium' },
];

export const createSpeechTopicsTableConf = ({ onDelete }) => [
  {
    getDisplay: (item) => TYPE_OPTIONS.find((opt) => opt.value === item.type)?.label || item.type,
    name: 'Type',
    textOptions: { withEllipsis: true },
    width: 90,
    sortable: true,
    sortValue: (item) => TYPE_OPTIONS.find((opt) => opt.value === item.type)?.label || item.type,
  },
  {
    getDisplay: (item) => item.locale || '',
    name: 'Locale',
    textOptions: { withEllipsis: true },
    width: 85,
    sortable: true,
    sortValue: (item) => item.locale || '',
  },
  {
    getDisplay: (item) => item.text,
    name: 'Text',
    textOptions: { size: TEXT_SIZE.H4, color: TEXT_COLOR.DARK_BLUE, withEllipsis: true },
    sortable: true,
    sortValue: (item) => (item.text || '').trim(),
  },
  {
    getDisplay: (item) =>
      (item.population || [])
        .map((p) => POPULATION_OPTIONS.find((opt) => opt.value === p)?.label || p)
        .join(', '),
    name: 'Population',
    textOptions: { withEllipsis: true },
    width: 120,
    sortable: true,
    sortValue: (item) => (item.population || []).join(','),
  },
  {
    getDisplay: (item) => (
      <DeleteActionButton
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(item.id);
        }}
        title="Delete"
      >
        <DeleteIcon color="error" sx={{ fontSize: 22 }} />
      </DeleteActionButton>
    ),
    name: '',
    width: 40,
  },
];
